import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap/lib';
import './EmployeeCompanyDataItem.scss';

export default class EmployeeCompanyDataItem extends Component {
  static propTypes = {
    companyData: PropTypes.shape({
      total_companies: PropTypes.number,
      total_incumbents: PropTypes.number
    }).isRequired,
    isMP: PropTypes.bool,
    isPayscaleRow: PropTypes.bool,
    companyDataInDropdown: PropTypes.bool
  };

  render() {
    const { isMP, isPayscaleRow, companyData, companyDataInDropdown } = this.props;

    if (!companyData || !companyData.total_companies || !companyData.total_incumbents) {
      return null;
    }

    const tooltipCountCompany = (
      <Tooltip id="ttCountCompany" className="dropdown__tooltip">
        Number of Companies
      </Tooltip>
    );
    const tooltipCountEmployee = (
      <Tooltip id="ttCountEmployee" className="dropdown__tooltip">
        Number of Employees
      </Tooltip>
    );

    const tooltipCompanyPlus = (
      <Tooltip id="tooltipCompanyPlus" className="dropdown__tooltip">
        <span className="heading">What is with the (+) next to company count?</span>
        <br />
        <span className="body">
          The number of different companies represented by this data is at least the number shown here. To ensure we get
          the highest quality data possible, we do not require data providers to disclose company names. We know the
          minimum count, and the maximum possible based on the number of incumbents.
        </span>
      </Tooltip>
    );

    let useIcon = isPayscaleRow && !companyDataInDropdown ? <i className="icon-sort-down popover--arrow" /> : '';
    return (
      <span className="profile-analyzed__dropdown">
        <span className="dropdown__total-company">
          <OverlayTrigger placement="top" overlay={tooltipCountCompany}>
            <i className="icon-building-filled dropdown--icons" />
          </OverlayTrigger>
          {companyDataInDropdown ? (
            <OverlayTrigger placement={isMP ? 'bottom' : 'right'} overlay={tooltipCompanyPlus}>
              <span className="dropdown__total--number">{companyData.total_companies + '+'}</span>
            </OverlayTrigger>
          ) : (
            <span className="dropdown__total--number">{companyData.total_companies}</span>
          )}
        </span>

        <span className="dropdown__total-incumbents">
          <OverlayTrigger placement="top" overlay={tooltipCountEmployee}>
            <i className="icon-users dropdown--icons" />
          </OverlayTrigger>
          <span className="dropdown__total--number">{companyData.total_incumbents}</span>
        </span>
        {useIcon}
      </span>
    );
  }
}
